var _rect, _rect2, _rect3, _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountSecure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 16,
    width: 68,
    height: 66,
    rx: 6,
    ry: 6,
    fill: "#fff",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 82,
    width: 11,
    height: 5,
    fill: "#fff",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 82,
    width: 11,
    height: 5,
    fill: "#fff",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47,70.15S61.89,62.49,61.89,51V37.6L47,31.85,32.11,37.6V51C32.11,62.49,47,70.15,47,70.15Z",
    fill: "#eff1ff",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.56,48H52.44A1.6,1.6,0,0,1,54,49.59v5.73A1.6,1.6,0,0,1,52.44,57H41.56A1.6,1.6,0,0,1,40,55.32V49.59A1.6,1.6,0,0,1,41.56,48Z",
    fill: "#6576ff",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43,48V45a4,4,0,0,1,8,0v3",
    fill: "none",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.67,
    cy: 52.79,
    r: 0.91,
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 17,
    r: 14,
    fill: "#fff",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 17,
    r: 10.5,
    fill: "#e3e7fe"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.46,20.47l-4.41-4.41a3.4,3.4,0,0,0,.26-1.31A3.34,3.34,0,1,0,21,18.1a3.41,3.41,0,0,0,1.31-.27l1.44,1.45a.33.33,0,0,0,.23.09l.79,0,0,.79a.32.32,0,0,0,.09.23.27.27,0,0,0,.23.08l.79,0,0,.79a.31.31,0,0,0,.09.22.29.29,0,0,0,.22.09l.79,0,0,.79a.3.3,0,0,0,.09.24.32.32,0,0,0,.21.08h0l1.21-.14a.3.3,0,0,0,.27-.33l-.13-1.48Z",
    fill: "#6576ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.56,14.09a1,1,0,0,1-1.34,0,1,1,0,0,1,0-1.35,1,1,0,1,1,1.34,1.35Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.72,16.39h0l3.79,3.79a.22.22,0,0,1,0,.32h0a.24.24,0,0,1-.32,0l-3.75-3.76Z",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.32,
    y: 11.6,
    width: 11,
    height: 11,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSecure);
export default __webpack_public_path__ + "static/media/account-secure.bd1b5b41ed3a1bdb52c43b1299ecdbc0.svg";
export { ForwardRef as ReactComponent };